import axios from '@axios'

export const state = {
  userInvoices: [],
}

export const getters = {
  allUserInvoices: (state) => state.userInvoices,
}

export const mutations = {
  GET_USER_INVOICES: (state, resp) => {
    if (!resp) return null
    state.userInvoices = resp
  },
  CREATE_USER_INVOICE: (state, resp) => {
    if (!resp) return null
    state.userInvoices = [...state.userInvoices, resp]
  },
}

export const actions = {
  async createUserInvoice({ commit }, form) {
    form.fees = form.fees.filter((fee) => fee.amount)
    return axios.post('/api/user-invoices', form)
  },
  async getUnavailableFees({ commit, dispatch }, carId) {
    return axios.get(`/api/user-invoice/${carId}/unavailable-fees`)
  },
  async getUserInvoiceItems({ commit, dispatch }, id) {
    return axios.get(`/api/user-invoice/invoice/${id}`)
  },
  async getUserInvoices({ commit, dispatch }, id) {
    return axios.get(`/api/user-invoices/media/${id}`).then((resp) => {
      commit('GET_USER_INVOICES', resp.data)
    })
  },
  getUserInvoice({ commit, dispatch }, id) {
    return axios.get(`/api/user-invoices/media/${id}`)
  },
}
